<div class="hero-dark"></div>
<div class="container page">
  @if(loading_page){
  <div class="backdrop-mini-loader">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  </div>
  }@else { @if(booking){
  <div class="mb-4 md:mb-0">
    <h1>La mia <span class="green">prenotazione</span></h1>
    <span>Pratica #{{ booking.identifier }}</span>
  </div>

  <div class="profile-container mt-4 mb-6">
    <div class="grid">
      <div class="col-12 md:col-4 md:pr-4">
        <div class="profile-card">
          <div
            class="bg-travel"
            [ngStyle]="{
              'background-image':
                'url(' +
                (booking.travel
                  | travelImagePipe
                  | imagePipe : 'travel' : 'md') +
                ')'
            }"
          ></div>

          <div class="info">
            <h3 class="m-0 mb-4">
              <a class="link-o" (click)="goTo()">{{ booking.travel.name }}</a>
            </h3>
            <div class="flex align-items-center gap-3 mb-3">
              <img src="/assets/media/icons/departures.png" />
              <small
                ><strong
                  >{{ booking.travel.from_date | date : "dd MMMM yyyy" }} -
                  {{ booking.travel.to_date | date : "dd MMMM yyyy" }}</strong
                ></small
              >
            </div>
            <div class="flex align-items-center gap-3 mb-3">
              <img src="/assets/media/icons/back-in-time.png" />
              <small>{{ dates | daysAndNights }}</small>
            </div>
            <div class="flex align-items-center gap-3 mb-3">
              @for (c of booking.travel.categories; track $index) {
              @if(booking.travel.categories.length === 1){
              <div class="flex align-items-center gap-3">
                <img [src]="c.category.id | travelType" height="24" />
                <small>{{ c.category.name }}</small>
              </div>
              }@else{
              <div class="flex align-items-center gap-1 mr-2 flex-wrap">
                <img
                  [src]="c.category.id | travelType"
                  height="24"
                  [pTooltip]="c.category.name"
                />
                <!-- <small>{{ c.category.name }}</small> -->
              </div>
              } }
            </div>
            <div class="flex align-items-center gap-3">
              <img src="/assets/media/icons/group.png" />
              <!-- <small>Fino a {{booking.travel.max_members}} partecipanti</small> -->
              @if(travelers.length > 0){
              <div class="avatar-list group-wrap">
                <p-avatarGroup>
                  @for (a of travelers; track $index) {
                  <p-avatar
                    [image]="a.profile_picture | imagePipe : 'user-w' : 'sm'"
                    shape="circle"
                    [pTooltip]="a.name ? a.name : a.username"
                    tooltipPosition="bottom"
                    [routerLink]="['/user/profile', a.username]"
                  ></p-avatar>
                  } @if (travelers.length < totalRecords) {
                  <p-avatar
                    label="..."
                    shape="circle"
                    (click)="loadMoreTravelers()"
                    styleClass="avatar-text"
                    [style]="{
                      'background-color': '#3c4e58',
                      color: '#ffffff'
                    }"
                  ></p-avatar>
                  }
                </p-avatarGroup>
              </div>
              }
            </div>
          </div>

          <div class="organization-info">
            @if(booking.travel.player){
            <div class="flex align-items-center gap-3">
              <p-avatar
                [image]="
                  booking.travel.player.logo | imagePipe : 'registry' : 'sm'
                "
                shape="circle"
              ></p-avatar>
              <div class="flex flex-column gap-2">
                <small
                  >Offerto da: <br />
                  <strong class="clickable" (click)="goTo()">{{
                    booking.travel.player.name
                  }}</strong>
                </small>
              </div>
            </div>
            }@else {
            <div class="flex align-items-center gap-3">
              @if(this.booking.travel.assignment &&
              (this.booking.travel.assignment.status.id ===
              enumAssignmentStatus.ACCEPTED)){
              <p-avatar
                [image]="
                  booking.travel.assignment.target_user.profile_picture
                    | imagePipe : 'user' : 'sm'
                "
                shape="circle"
              ></p-avatar>
              <div
                class="flex flex-column gap-2"
                [routerLink]="[
                  '/user/profile',
                  booking.travel.assignment.target_user.username
                ]"
              >
                <small
                  >Tour Leader: <br />
                  <strong class="clickable"
                    >{{ booking.travel.assignment.target_user.name }}
                    {{
                      booking.travel.assignment.target_user.last_name
                    }}</strong
                  >
                </small>
              </div>
              }@else {
              <p-avatar
                [image]="
                  booking.travel.related_user.profile_picture
                    | imagePipe : 'user' : 'sm'
                "
                shape="circle"
              ></p-avatar>
              <div
                class="flex flex-column gap-2"
                [routerLink]="[
                  '/user/profile',
                  booking.travel.related_user.username
                ]"
              >
                <small
                  >Organizzatore: <br />
                  <strong class="clickable"
                    >{{ booking.travel.related_user.name }}
                    {{ booking.travel.related_user.last_name }}</strong
                  >
                </small>
              </div>
              }
            </div>
            }
          </div>
        </div>
      </div>

      <div class="col-12 md:col-8">
        @if(!booking.travel.funding){ @switch (booking.status.id) { @case (2) {
        <div class="bg-muted-o alert-in-page mb-3">
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/alert-g.png" width="40" />
            <div class="flex flex-column gap-1">
              <strong>È quasi tutto pronto</strong>
              <small
                >L'acconto del viaggio è stato pagato correttamente, ora manca
                solo il saldo!</small
              >
            </div>
          </div>
        </div>
        } @case (3) {
        <div class="bg-muted-t alert-in-page mb-3">
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/checked-64.png" width="40" />
            <div class="flex flex-column gap-1">
              <strong>È tutto pronto</strong>
              <small>Il saldo del viaggio è stato completato!</small>
            </div>
          </div>
        </div>
        } @case (4) {
        <div class="bg-muted-o alert-in-page mb-3">
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/alert-g.png" width="40" />
            <div class="flex flex-column gap-1">
              <strong>Prenotazione sospesa</strong>
              <small
                >Questa prenotazione è stata temporaneamente sospesa.</small
              >
            </div>
          </div>
        </div>
        } @case (5) {
        <div class="muted-r-bg alert-in-page mb-3">
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/alert-g.png" width="40" />
            <div class="flex flex-column gap-1">
              <strong>Prenotazione cancellata</strong>
              <small>Questa prenotazione è stata cancellata.</small>
            </div>
          </div>
        </div>
        } @case (6) {
        <div class="muted-r-bg alert-in-page mb-3">
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/alert-g.png" width="40" />
            <div class="flex flex-column gap-1">
              <strong>Prenotazione rimborsata</strong>
              <small>Questa prenotazione è stata rimborsata.</small>
            </div>
          </div>
        </div>
        } } } @else {
        <div class="bg-muted-o alert-in-page mb-3">
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/alert-g.png" width="40" />
            <div class="flex flex-column gap-1">
              <strong>Giornata Mondiale della Gioventù</strong>
              <small>Questo viaggio è in fase di raccolta fondi... </small>
            </div>
          </div>
        </div>
        }

        <h3 class="m-0 mb-3">Gestione <span class="orange">pagamenti</span></h3>
        <div class="mt-3 mb-6">
          <p-table [value]="booking.payments">
            <ng-template pTemplate="header">
              <tr>
                <th></th>
                <th>Importo</th>
                <th>Scadenza</th>
                <th>Pagamento</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-p>
              <tr>
                <td [innerHTML]="p.type | paymentMethod"></td>
                <td>
                  <div class="flex align-items-center gap-1">
                    {{ p.amount | currency : p.currency : "symbol" : ".0-0" }}
                    <div
                      [innerHTML]="p.status.id | paymentStatus"
                      [pTooltip]="p.status.id | paymentStatusLabel"
                      tooltipPosition="top"
                    ></div>
                  </div>
                </td>
                <td>
                  {{ p.expires_on | date : "dd/MM/yyyy" }}
                </td>
                <td>
                  @if ((p.status.id === enumPaymentStatus.NOT_PAYED) && (p.type
                  === enumPaymentMethod.STRIPE_TRANSFER)) {
                  <div class="flex justify-content-end">
                    <p-button
                      label="Salda pagamento"
                      size="small"
                      styleClass="screen slide-o px-4"
                      (click)="confirmFullPayment(p.identifier)"
                    ></p-button>
                    <div class="mobile actions">
                      <p-button
                        icon="pi pi-credit-card"
                        size="small"
                        [text]="true"
                        (click)="confirmFullPayment(p.identifier)"
                      ></p-button>
                    </div>
                  </div>
                  }@else {
                  <span>{{ p.payed_on | date : "dd/MM/yyyy" }}</span>
                  }
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div
            class="b-bottom mb-6 p-3 flex align-items-center justify-content-end gap-2"
          >
            <small class="grey-text">Totale</small>
            <h1 class="m-0 green">
              {{
                booking.amount
                  | currency : booking.travel.currency : "symbol" : ".0-0"
              }}
            </h1>
          </div>
          @if(booking.travel.funding){
          <div class="flex align-items-center justify-content-end gap-2 mb-3">
            <p-button
              label="Aggiungi versamento"
              size="small"
              styleClass="slide-o px-4"
              (click)="addPaymentModal = true"
            ></p-button>
          </div>
          }
        </div>

        <h3 class="m-0 mb-3">
          Intestatario<span class="green"> pratica</span>
        </h3>
        <div class="mb-6">
          <div class="grid">
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Intestatario</small>
                <span
                  >{{ booking.accountholder_name }}
                  {{ booking.accountholder_last_name }}</span
                >
              </div>
            </div>
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Paese</small>
                <span>{{ booking.accountholder_country_iso }}</span>
              </div>
            </div>
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Indirizzo</small>
                <span>{{ booking.accountholder_address }}</span>
              </div>
            </div>
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">CAP</small>
                <span>{{ booking.accountholder_zip_code }}</span>
              </div>
            </div>
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Città</small>
                <span
                  >{{ booking.accountholder_city }},
                  {{ booking.accountholder_province }}</span
                >
              </div>
            </div>
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">C.F.</small>
                <span>{{ booking.accountholder_fiscal_code }}</span>
              </div>
            </div>
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Contatti</small>
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-phone grey-text text-sm"></i>
                  <span>{{ booking.accountholder_mobile_phone }}</span>
                </div>
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-envelope grey-text text-sm"></i>
                  <span>{{ booking.accountholder_email }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        @if(booking.travel.pricing_mode != 2){
        <h3 class="m-0 mb-3">
          Informazioni <span class="orange">stanze</span>
        </h3>
        <div class="rooms mb-6">
          <p-accordion [multiple]="true">
            <p-accordionTab
              [header]="getRoomHeader(t)"
              *ngFor="let t of booking.rooms; let last = last"
              [ngClass]="{ last: last }"
            >
              <div *ngFor="let d of t.members" class="personal-info py-4">
                <div class="grid">
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Ospite:</small>
                      <span
                        >{{ d.name }} {{ d.last_name }} ({{ d.gender }})</span
                      >
                    </div>
                  </div>
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Disabile:</small>
                      @if(d.disabled === true){
                      <i class="pi pi-check"></i>
                      }@else {
                      <i class="pi pi-times"></i>
                      }
                    </div>
                  </div>
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Telefono:</small>
                      <span>{{ d.phone_number }}</span>
                    </div>
                  </div>
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Email:</small>
                      <span>{{ d.email_address }}</span>
                    </div>
                  </div>
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Data di nascita:</small>
                      <span>{{ d.date_of_birth | date : "dd/MM/yyyy" }}</span>
                    </div>
                  </div>
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Num. documento:</small>
                      <span
                        >{{
                          d.document_type === "PT"
                            ? "Passaporto"
                            : "Carta d'identità"
                        }}
                        {{ d.document_number }}</span
                      >
                    </div>
                  </div>
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Scadenza documento:</small>
                      <span>{{
                        d.document_exp_date | date : "dd/MM/yyyy"
                      }}</span>
                    </div>
                  </div>
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Data emissione documento:</small>
                      <span>{{
                        d.document_release_date | date : "dd/MM/yyyy"
                      }}</span>
                    </div>
                  </div>
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Cittadinanza:</small>
                      <span>{{ d.nationality }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </p-accordionTab>
          </p-accordion>
        </div>
        }@else{ @if(!booking.travel.funding){
        <h3 class="m-0 mb-3">
          Informazioni <span class="orange">pacchetti acquistati</span>
        </h3>
        <div class="rooms mb-6">
          <p-accordion [multiple]="true">
            <p-accordionTab
              [header]="getPackageHeader(t)"
              *ngFor="let t of booking.packages; let last = last"
              [ngClass]="{ last: last }"
            >
              <div
                class="flex flex-column gap-2 bg-muted-t p-2 border-round-md"
              >
                <div
                  class="grey-text p-0 font-normal text-sm"
                  [innerHTML]="t.travel_package.description"
                ></div>
                <div class="flex align-items-center gap-1">
                  <img src="/assets/media/icons/check-g.png" height="18" />
                  <small
                    >Ideato per
                    <b>{{ t.travel_package.n_partecipants }}</b> adult{{ t.travel_package.n_partecipants > 0 ? 'i' : 'o' }}.</small
                  >
                </div>
                <div class="flex align-items-center gap-1">
                  <img src="/assets/media/icons/check-g.png" height="18" />
                  <small
                    >Numero massimo di bambini (2-8 anni) ammessi:
                    <b>{{ t.travel_package.max_n_children }}</b
                    >.</small
                  >
                </div>
                <div class="flex align-items-center gap-1">
                  <img src="/assets/media/icons/check-g.png" height="18" />
                  <small
                    >Numero massimo di neonati (0-2 anni) ammessi:
                    <b>{{ t.travel_package.max_n_infants }}</b
                    >.</small
                  >
                </div>
                <div class="flex align-items-end justify-content-end gap-1">
                  <small class="grey-text mb-1"
                    >Prezzo per numero minimo di adulti:</small
                  >
                  <h2 class="green m-0">
                    {{
                      t.travel_package.price_per_person
                        | currency : booking.travel.currency
                    }}
                  </h2>
                </div>
              </div>
              <div *ngFor="let d of t.members" class="personal-info py-4">
                <div class="grid">
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Ospite:</small>
                      <span
                        >{{ d.name }} {{ d.last_name }} ({{ d.member_type }}
                        {{ d.gender }})</span
                      >
                    </div>
                  </div>
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Disabile:</small>
                      @if(d.disabled === true){
                      <i class="pi pi-check"></i>
                      }@else {
                      <i class="pi pi-times"></i>
                      }
                    </div>
                  </div>
                  <!-- <div class="col-12 md:col-6">
                                          <div class="flex flex-column gap-1">
                                              <small class="grey-text">Codice fiscale:</small>
                                              <span>{{d.fiscal_code}}</span>
                                          </div>
                                      </div> -->
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Data di nascita:</small>
                      <span>{{ d.date_of_birth | date : "dd/MM/yyyy" }}</span>
                    </div>
                  </div>
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Num. documento:</small>
                      <span
                        >{{
                          d.document_type === "PT"
                            ? "Passaporto"
                            : "Carta d'identità"
                        }}
                        {{ d.document_number }}</span
                      >
                    </div>
                  </div>
                  <div class="col-12 md:col-6">
                    <div class="flex flex-column gap-1">
                      <small class="grey-text">Scadenza documento:</small>
                      <span>{{
                        d.document_exp_date | date : "dd/MM/yyyy"
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              @if(t.notes){
              <div class="bg-muted-o p-3 border-round-md mt-3">
                <small class="grey-text">Note:</small>
                <div class="mt-2" [innerHTML]="t.notes"></div>
              </div>
              }
            </p-accordionTab>
          </p-accordion>
        </div>
        } } @if(booking.addl_services.length > 0 || booking.travel.attachments
        === []){
        <h3 class="m-0 mb-3">
          Informazioni <span class="green">aggiuntive</span>
        </h3>
        }
        <div>
          <div class="grid">
            @if(booking.travel.optional_flight_purchase){
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Volo</small>
                @if(booking.with_flights){
                <span>Viaggio acquistato senza preferenze sul volo</span>
                }@else {
                <span>Viaggio acquistato senza volo</span>
                }
              </div>
            </div>
            } @if(booking.addl_services.length > 0){
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Servizi aggiuntivi</small>
                @for (s of booking.addl_services; track $index) {
                <div class="flex flex-column gap-1">
                  <b>{{ s.title }}</b>
                  <h4 class="green m-0">
                    {{
                      s.price
                        | currency : booking.travel.currency : "symbol" : ".0-0"
                    }}
                  </h4>
                  @if (s.qty) {
                  <small> Aquistato x{{ s.qty }} </small>
                  } @else {
                  <small>Non acquistato</small>
                  }
                </div>
                }
              </div>
            </div>
            } @if(booking.travel.attachments!.length > 0){
            <div class="col-12 md:col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Documenti</small>
                @if(booking.travel.attachments){
                <a class="block flex align-items-center gap-2 mt-3">
                  <img src="/assets/media/icons/pdf.png" height="32" />
                  <div class="flex flex-column gap-1">
                    @for (a of booking.travel.attachments; track $index) {
                    <a
                      class="link-o"
                      [href]="environmentMediaUrl + '/' + a.attachment.path"
                      >Consulta i termini e condizioni</a
                    >
                    }
                  </div>
                </a>
                }@else {
                <span>Questo viaggi non ha allegati.</span>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  } }
</div>

<app-request></app-request>

<!-- Modal aggiungi pagamento -->

<p-dialog
  header="Aggiungi versamento"
  [(visible)]="addPaymentModal"
  [modal]="true"
  [style]="{ width: '35rem' }"
>
  <ng-template pTemplate="body">
    <p>Scegli l'importo da versare:</p>
    <p-slider
      class="w-full mt-5 mb-3"
      [min]="0"
      [max]="500"
      [step]="50"
      [formControl]="addPaymentAmount"
    ></p-slider>

    <div class="text-center">
      <h1>
        {{ addPaymentAmount.value | currency : "EUR" : "symbol" : ".2-2" }}
      </h1>
    </div>
    <div class="modal-footer flex justify-content-between">
      <div class="w-full">
        <p-button
          label="Annulla"
          size="small"
          (click)="addPaymentModal = false"
          [outlined]="true"
        ></p-button>
      </div>
      <div class="w-full ml-3">
        <p-button
          label="Salva"
          size="small"
          (click)="addPayment()"
          styleClass="slide-o"
          [disabled]="addPaymentAmount.value! < 50"
          [loading]="addPaymentLoading"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>
